import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PortalService {
    private readonly setPortalContentSubject = new Subject<TemplatePortal | null>();

    public readonly extraButtons$ = this.setPortalContentSubject.asObservable();
    public setTemplate(templateRef: TemplateRef<unknown>, viewContainerRef: ViewContainerRef) {
        this.setPortalContentSubject.next(new TemplatePortal(templateRef, viewContainerRef));
    }

    public clear() {
        this.setPortalContentSubject.next(null);
    }
}
